import { Box, Button, Flex, FormControl, Input, Text } from '@chakra-ui/react';
import { useFormikContext } from 'formik';

const LargestWeight = ({
  next,
  prev,
}: {
  next: () => void;
  prev: () => void;
}): JSX.Element => {
  const {
    values: { largestWeight },
    setFieldValue,
    handleBlur,
  } = useFormikContext<ApplicationQuestionsValues>();

  return (
    <Flex direction="column" width="100%">
      <Flex direction="column" bg="custom.levoAlabaster" py="61.5px" px={6}>
        <Text textStyle="heading3" fontWeight="bold">
          What is the largest person you can manage in pounds?
        </Text>
        <FormControl
          id="largestWeight"
          display="flex"
          flexDirection="column"
          mt={6}
        >
          <Flex
            direction="row"
            justifyContent="center"
            alignItems="center"
            mt={4}
            mb={2}
          >
            <Box width="100px">
              <Input
                type="text"
                onChange={(e) =>
                  setFieldValue(
                    'largestWeight',
                    Number(e.currentTarget.value.replace(/\D/g, '')),
                  )
                }
                value={largestWeight}
                borderRadius="30px"
                borderColor="custom.levoLightGray"
                focusBorderColor="custom.levoYellow"
                errorBorderColor="crimson"
                placeholder="Number"
                background="custom.levoAlabaster"
                onBlur={handleBlur}
              />
            </Box>
            <Text fontWeight="bold" ml={2}>
              pounds
            </Text>
          </Flex>
        </FormControl>
      </Flex>
      <Flex width="100%" justifyContent="space-between" mt={6}>
        <Button
          width="fit-content"
          height="fit-content"
          bg="custom.levoDarkSnow"
          borderRadius="8px"
          mt={6}
          py={4}
          px={6}
          onClick={prev}
        >
          <Text textStyle="body" fontWeight={700} color="custom.levoBlue">
            Back
          </Text>
        </Button>
        <Button
          width="fit-content"
          height="fit-content"
          bg="custom.levoBlue"
          borderRadius="8px"
          mt={6}
          py={4}
          px={6}
          isDisabled={!largestWeight}
          onClick={next}
        >
          <Text textStyle="body" fontWeight={700} color="white">
            Next
          </Text>
        </Button>
      </Flex>
    </Flex>
  );
};

export default LargestWeight;
